module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "region-select"
  }, [(_vm.allArea.length == 1) ? _c('div', {
    staticClass: "info-control region",
    staticStyle: {
      "margin-top": "0.05rem"
    },
    on: {
      "click": _vm.showPanel
    }
  }, [(_vm.allArea.length == 1) ? _c('span', [_vm._v("请选择区域、卫生服务中心、签约团队")]) : _vm._e()]) : _c('div', {
    staticClass: "info-control region",
    staticStyle: {
      "margin-top": "0.05rem"
    },
    on: {
      "click": _vm.showPanel
    }
  }, _vm._l((_vm.allArea), function(item, index) {
    return _c('span', {
      staticClass: "choosed"
    }, [_vm._v(_vm._s(_vm.getStr(item)) + "\n      "), (index < _vm.allArea.length - 1) ? _c('span', [_vm._v(">")]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "region-panel"
  }, [_c('div', {
    staticClass: "region-city"
  }, [_c('div', {
    staticClass: "areaList"
  }, [_vm._v("\n        已选:"), _vm._l((_vm.allArea), function(item, index) {
    return _c('span', {
      staticClass: "choosed"
    }, [_vm._v(_vm._s(item)), (index < _vm.allArea.length - 1) ? _c('span', [_vm._v(">")]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "region-list",
    attrs: {
      "infinite-scroll-disabled": _vm.isDisabled,
      "infinite-scroll-distance": "10",
      "infinite-scroll-throttle-delay": "2000"
    }
  }, _vm._l((_vm.region), function(item, index) {
    return _c('div', {
      staticClass: "info-control region",
      staticStyle: {
        "margin-top": "0.05rem"
      },
      on: {
        "click": function($event) {
          return _vm.selectArea(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))])])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b52042a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegionSelect.vue
// module id = 805
// module chunks = 0